module.exports = __webpack_public_path__ + "static/5-889dc00034628175889e90ab28253b06.jpg";